<app-breadcrumb [title]="'Multas'" [items]="['Personas']" [active_item]="'Multas'"></app-breadcrumb>
<div class="container-fluid">
<div class="card">
   <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="icofont icofont-safety me-2"></i>
      <h5 class="mb-0"><strong>LISTADO DE MULTAS E INFRACCIONES</strong></h5>
    </div>

  <div class="card-body custom-datatable noscroll">
    <div class="row mb-12">
      <div class="col-sm-12 col-md-3 my-3">
        <div class="input-group">
          <select class="form-select" [(ngModel)]="selectedEstado" (change)="filterData1()">
            <option value="" selected>TODOS</option>
            <option value="3">ACUERDO DE PAGO</option>
            <option value="1">PAGADO</option>
            <option value="2">PENDIENTE DE PAGO</option>
          </select>
          <span class="input-group-text">
            <i class="fa fa-filter"></i>
          </span>
        </div>
      </div>
      <div class="col-sm-12 col-md-3 ms-auto mt-2 mt-md-3">
        <div class="input-group">
          <input type="text" class="form-control" placeholder="Buscar por cédula o nombre..."
            [(ngModel)]="searchText" (input)="filterData()" />
          <span class="input-group-text">
            <i class="fa fa-search"></i>
          </span>
        </div>
      </div>
    </div>

    <!-- Skeleton loader -->
    <div *ngIf="loading" class="custom-datatable table-responsive">
      <table class="table table-hover table-bordered">
        <thead class="bg-primary">
          <tr>
            <th class="text-center"><div class="skeleton skeleton-text" style="width: 80px; margin: 0 auto;"></div></th>
            <th class="text-center"><div class="skeleton skeleton-text" style="width: 90px; margin: 0 auto;"></div></th>
            <th class="text-center"><div class="skeleton skeleton-text" style="width: 120px; margin: 0 auto;"></div></th>
            <th class="text-center"><div class="skeleton skeleton-text" style="width: 60px; margin: 0 auto;"></div></th>
            <th class="text-center"><div class="skeleton skeleton-text" style="width: 70px; margin: 0 auto;"></div></th>
            <th class="text-center"><div class="skeleton skeleton-text" style="width: 90px; margin: 0 auto;"></div></th>
            <th class="text-center"><div class="skeleton skeleton-text" style="width: 70px; margin: 0 auto;"></div></th>
            <th class="text-center"><div class="skeleton skeleton-text" style="width: 70px; margin: 0 auto;"></div></th>
            <th class="text-center"><div class="skeleton skeleton-text" style="width: 70px; margin: 0 auto;"></div></th>
            <th class="text-center"><div class="skeleton skeleton-text" style="width: 90px; margin: 0 auto;"></div></th>
            <th class="text-center"><div class="skeleton skeleton-text" style="width: 70px; margin: 0 auto;"></div></th>
            <th class="text-center"><div class="skeleton skeleton-text" style="width: 120px; margin: 0 auto;"></div></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let i of [1,2,3,4,5,6,7,8]">
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text"></div></td>
            <td><div class="skeleton skeleton-text"></div></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="!loading" class="custom-datatable table-responsive">
      <table class="table table-hover table-bordered" id="tblMultas">
        <thead class="bg-primary">
          <tr>
            <th class="text-center" (click)="sortData('fecha')" style="cursor: pointer;">
              <strong>FECHA</strong>
              <i class="fa" [ngClass]="{
              'fa-sort-up': sortColumn === 'fecha' && sortDirection === 'asc',
              'fa-sort-down': sortColumn === 'fecha' && sortDirection === 'desc',
              'fa-sort': sortColumn !== 'fecha'
            }"></i>
            </th>
      
            <th class="text-center" (click)="sortData('documento')" style="cursor: pointer;">
              <strong>DOCUMENTO</strong>
              <i class="fa" [ngClass]="{
              'fa-sort-up': sortColumn === 'documento' && sortDirection === 'asc',
              'fa-sort-down': sortColumn === 'documento' && sortDirection === 'desc',
              'fa-sort': sortColumn !== 'documento'
            }"></i>
            </th>
      
            <th class="text-center" (click)="sortData('nombre')" style="cursor: pointer;">
              <strong>NOMBRE</strong>
              <i class="fa" [ngClass]="{
              'fa-sort-up': sortColumn === 'nombre' && sortDirection === 'asc',
              'fa-sort-down': sortColumn === 'nombre' && sortDirection === 'desc',
              'fa-sort': sortColumn !== 'nombre'
            }"></i>
            </th>
      
            <th class="text-center" (click)="sortData('tipo')" style="cursor: pointer;">
              <strong>TIPO</strong>
              <i class="fa" [ngClass]="{
              'fa-sort-up': sortColumn === 'tipo' && sortDirection === 'asc',
              'fa-sort-down': sortColumn === 'tipo' && sortDirection === 'desc',
              'fa-sort': sortColumn !== 'tipo'
            }"></i>
            </th>
      
            <th class="text-center" (click)="sortData('numero')" style="cursor: pointer;">
              <strong>NUMERO</strong>
              <i class="fa" [ngClass]="{
              'fa-sort-up': sortColumn === 'numero' && sortDirection === 'asc',
              'fa-sort-down': sortColumn === 'numero' && sortDirection === 'desc',
              'fa-sort': sortColumn !== 'numero'
            }"></i>
            </th>
      
            <th class="text-center" (click)="sortData('codigo')" style="cursor: pointer;">
              <strong>INFRACCIÓN</strong>
              <i class="fa" [ngClass]="{
              'fa-sort-up': sortColumn === 'codigo' && sortDirection === 'asc',
              'fa-sort-down': sortColumn === 'codigo' && sortDirection === 'desc',
              'fa-sort': sortColumn !== 'codigo'
            }"></i>
            </th>
      
            <th class="text-center" (click)="sortData('valortotal')" style="cursor: pointer;">
              <strong>VALOR</strong>
              <i class="fa" [ngClass]="{
              'fa-sort-up': sortColumn === 'valortotal' && sortDirection === 'asc',
              'fa-sort-down': sortColumn === 'valortotal' && sortDirection === 'desc',
              'fa-sort': sortColumn !== 'valortotal'
            }"></i>
            </th>
      
            <th class="text-center" (click)="sortData('vrpagado')" style="cursor: pointer;">
              <strong>PAGOS</strong>
              <i class="fa" [ngClass]="{
              'fa-sort-up': sortColumn === 'vrpagado' && sortDirection === 'asc',
              'fa-sort-down': sortColumn === 'vrpagado' && sortDirection === 'desc',
              'fa-sort': sortColumn !== 'vrpagado'
            }"></i>
            </th>
      
            <th class="text-center" (click)="sortData('vrsaldo')" style="cursor: pointer;">
              <strong>SALDO</strong>
              <i class="fa" [ngClass]="{
              'fa-sort-up': sortColumn === 'vrsaldo' && sortDirection === 'asc',
              'fa-sort-down': sortColumn === 'vrsaldo' && sortDirection === 'desc',
              'fa-sort': sortColumn !== 'vrsaldo'
            }"></i>
            </th>
      
            <th class="text-center" (click)="sortData('fechacompromiso')" style="cursor: pointer;">
              <strong>COMPROMISO</strong>
              <i class="fa" [ngClass]="{
              'fa-sort-up': sortColumn === 'fechacompromiso' && sortDirection === 'asc',
              'fa-sort-down': sortColumn === 'fechacompromiso' && sortDirection === 'desc',
              'fa-sort': sortColumn !== 'fechacompromiso'
            }"></i>
            </th>
      
            <th class="text-center" (click)="sortData('estado')" style="cursor: pointer;">
              <strong>ESTADO</strong>
              <i class="fa" [ngClass]="{
              'fa-sort-up': sortColumn === 'estado' && sortDirection === 'asc',
              'fa-sort-down': sortColumn === 'estado' && sortDirection === 'desc',
              'fa-sort': sortColumn !== 'estado'
            }"></i>
            </th>
      
            <th class="text-center" (click)="sortData('observaciones')" style="cursor: pointer;">
              <strong>OBSERVACIONES</strong>
              <i class="fa" [ngClass]="{
              'fa-sort-up': sortColumn === 'observaciones' && sortDirection === 'asc',
              'fa-sort-down': sortColumn === 'observaciones' && sortDirection === 'desc',
              'fa-sort': sortColumn !== 'observaciones'
            }"></i>
            </th>
          </tr>
        </thead>
      
      
        <tbody>
          <tr
            *ngFor="let infraccion of filteredTableItems | paginate: { itemsPerPage: pageSize1, currentPage: page1 }; let i = index">
      
            <td class="text-center">{{ infraccion.fecha | date:'dd/MM/yyyy' }}</td>
            <td class="text-center">{{ infraccion.documento }}</td>
            <td class="text-uppercase text-justify">
              {{ infraccion.propietario?.primernombre }} {{ infraccion.propietario?.segundonombre }}
              {{ infraccion.propietario?.papellidos }} {{ infraccion.propietario?.seapellidos }}
            </td>
            <td class="text-center">{{ infraccion.tipo }}</td>
            <td class="text-center">{{ infraccion.numero }}</td>
            <td class="text-center">{{ infraccion.codigo }}</td>
            <td class="text-center">{{ infraccion.valortotal }}</td>
            <td class="text-center">{{ infraccion.vrpagado}}</td>
            <td class="text-center">{{ infraccion.vrsaldo}}</td>
            <td class="text-center">{{ infraccion.fechacompromiso | date:'dd/MM/yyyy' }}</td>
      
            <td class="text-center">
              <span class="badge" [ngClass]="infraccion.estadoMulta.color">
                {{ (infraccion.estadoMulta.descripcion) }}
              </span>
            </td>
      
      
            <td class="text-center">{{ infraccion.observaciones}}</td>
      
          </tr>
        </tbody>
      </table>

      <div class="d-flex justify-content-between align-items-center mt-4">
        <!-- Selector de registros por página alineado a la izquierda -->
        <div class="d-flex align-items-center">
          <label for="pageSize1" class="me-2">Mostrar:</label>
          <select id="pageSize1" class="form-select w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
            <option *ngFor="let size1 of [5, 10, 20, 50, 100]" [value]="size1">{{ size1 }}</option>
          </select>
          <span class="ms-2">registros por página</span>
        </div>

        <!-- Mostrar cantidad total de registros centrado -->
        <div class="text-center">
          Total Registros:
          <a class="badge badge-primary"><b>{{ filteredTableItems?.length || 0 }}</b></a>
        </div>



        <!-- Paginador alineado a la derecha -->
        <div class="text-end paginador-personalizado">
          <pagination-controls (pageChange)="page1 = $event" [maxSize]="5" [directionLinks]="true" [autoHide]="true"
            previousLabel="Anterior" nextLabel="Siguiente">
          </pagination-controls>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="btn-showcase text-center">
<button class="btn btn-outline-success-2x"
        type="button"
        placement="top"
        ngbTooltip="Exportar a Excel"
        (click)="exportarExcel('Listado_Multas')">
  <i class="icofont icofont-file-excel"></i> EXCEL
</button>


        <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF" (click)="
            exportToPDF(
              'tblMultas',
              'Listado_Multas',
              'Listado de Multas'
            )
          ">
          <i class="icofont icofont-file-pdf"></i> PDF
        </button>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid">
  <div class="col-xl-12 col-sm-12">
    <app-graficos-multas></app-graficos-multas>
  </div>
</div>